import { useSuspenseQuery, UseSuspenseQueryOptions } from "@tanstack/react-query";
import { User } from "@/types";
import { api, ErrorResponse } from "@/utils/api";
import { camelize } from "@/utils/api-helpers";

export const useUser = (
  projectId: string,
  userExternalId: string,
  options: Omit<UseSuspenseQueryOptions<unknown, ErrorResponse, User>, "queryKey"> = {}
) => {
  return useSuspenseQuery<unknown, ErrorResponse, User>({
    queryKey: ["projects", projectId, "users", userExternalId],
    queryFn: async (): Promise<User> => {
      const response = await api.get<User>(`/projects/${projectId}/users/${userExternalId}`);
      return camelize(response.data);
    },
    ...options
  });
};
